var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"requests__list_table"},[_c('div',{staticClass:"columns is-block-mobile columns--margin-1-mobile is-variable"},[_c('div',{staticClass:"column"}),_c('div',{staticClass:"column is-narrow"},[_c('component-button',{attrs:{"name":'requests-list-table-item-actions-approve',"theme":'primary',"disabled":!_vm.requestsLength || _vm.requestPending,"animate-loading":true,"animate-loading-event-name":'approve-all'},on:{"click":_vm.performApproveAllEnrolments}},[_vm._v("Approve all shown\n            ")])],1),_c('div',{staticClass:"column is-narrow"},[_c('component-button',{attrs:{"name":'requests-list-table-item-actions-reject',"theme":'default',"disabled":!_vm.requestsLength || _vm.requestPending,"animate-loading":true,"animate-loading-event-name":'reject-all'},on:{"click":_vm.performRejectAllEnrolments}},[_vm._v("Reject all shown\n            ")])],1)]),_c('component-separator'),_c('component-table',{attrs:{"labels":[
            {
                key: 'learnerName',
                title: 'Learner name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'courseName',
                title: 'Course name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'createdAt',
                title: 'Request date',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'enrolmentStatus',
                title: 'Request status',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'createdBy',
                title: 'Actioned by',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'actions',
                title: '',
                type: '',
                sortable: false
            }
        ],"items":_vm.items,"disabled":_vm.requestPending,"component-table-item":_vm.RequestsListTableItem,"sort-queryable":_vm.sortQueryable},on:{"emit-sort":_vm.handleSort,"emit-perform-get-items":_vm.emitPerformGetItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }